export const GEAR_FIELD_TYPE = {
  TEXT: 'text',
  NUMERIC: 'numeric',
  INT32: 'int',
  INT64: 'int64',
  BOOLEAN: 'boolean',
  DATE: 'date',
  DATETIME: 'datetime',
  MULTICHOICE: 'multichoice',
  LINK: 'link'
} as const;

export type GearFieldType = (typeof GEAR_FIELD_TYPE)[keyof typeof GEAR_FIELD_TYPE];

type GearFieldUnionType = 'boolean' | 'text' | 'numeric' | 'date';

export const GearFieldTypeToFilterType = (fieldType: GearFieldType): GearFieldUnionType => {
  if (fieldType.toLowerCase() === GEAR_FIELD_TYPE.DATETIME.toLowerCase()) {
    return GEAR_FIELD_TYPE.DATE;
  } else if (
    fieldType.toLowerCase() === GEAR_FIELD_TYPE.INT32.toLowerCase() ||
    fieldType.toLowerCase() === GEAR_FIELD_TYPE.INT64.toLowerCase()
  ) {
    return GEAR_FIELD_TYPE.NUMERIC;
  } else if (
    fieldType.toLowerCase() === GEAR_FIELD_TYPE.MULTICHOICE ||
    fieldType.toLowerCase() === GEAR_FIELD_TYPE.LINK
  ) {
    return GEAR_FIELD_TYPE.TEXT;
  } else {
    return fieldType as GearFieldUnionType;
  }
};
